import { Injectable } from '@angular/core';
import { PublicationFolder } from '../models/publicationfolder';
import { Storage } from '@ionic/storage';
import { Publication } from '../models/publication';
import { PublicationsService } from '../services/publications.service';
import { PublicationPipe } from 'src/app/pipes/publication.pipe';
import { IPublication } from '../core/actions/entity/publicationEntity';
import { PublicationListByProcessIdService } from '../core/actions/use-case/publication-list-by-process-id.service';
import { PublicationLocalRepositoryService } from '../module/actions/data/repository/publication-local-repository.service';

@Injectable({
  providedIn: 'root'
})
export class PublicationFolderService {

  publications:  { [key: string]: (IPublication)[] } = {};
  publicationList: { [key: string]: Publication[] } = {};
  FolderDetails: { [key: string]: PublicationFolder } = {};
  restoreFolder: {} = {}
  keyName: string
  showLoader = false
  publicationPipe = new PublicationPipe()
  getpublication = [];
  gotoAction: string | false

  constructor(
    private storage: Storage,
    private publicationService: PublicationsService,
    private publicationListByProcessIdService: PublicationListByProcessIdService,
    private publicationLocalRepo: PublicationLocalRepositoryService,
  ) { }

  clear() {
    this.publicationList = {};
    this.FolderDetails = {};
    this.restoreFolder = {}
    this.showLoader = false
    this.publicationPipe = new PublicationPipe()
    this.getpublication = [];
  }

  async loadPublications(processId: number) {

    var id = processId+0

    this.showLoader = true;

    if (!this.publications[id]) {
      this.publications[id] = []

      const result = await this.publicationLocalRepo.find({processId: id});

      if(result.isOk()) {
        this.publications[id] = result.value;
      }
    }

    const result = await this.publicationListByProcessIdService.execute(id);

    if(result.isOk()) {
      for(const item of result.value.added) {
        this.publications[id].push(item);
      }

      // handle removed
      for (const item of result.value.remove) {
        this.publications[id] = this.publications[id].filter(f => f.documentId !== item.documentId);
      }

      // handle updated
      for (const item of result.value.updated) {
        const index = this.publications[id].findIndex(f => f.documentId === item.documentId);
        if (index !== -1) {
          this.publications[id][index] = item; // replace with updated version
        } else {
          this.publications[id].push(item); // if not found, just add it
        }
      }
    }

    this.publications[id] = this.publications[id].sort((a, b) => {
      const dateA = new Date(a.dateIndex).getTime();
      const dateB = new Date(b.dateIndex).getTime();
      return dateB - dateA; // Revertendo a ordem aqui
    });

    this.showLoader = false;
  }

  createPublicationList(folderId) {
    if (!this.publicationList[folderId]) {
      this.publicationList[folderId] = []
    }
    if (!this.FolderDetails[folderId]) {
      this.FolderDetails[folderId] = new PublicationFolder();
    }
  }

  getFromDB(folderId: any) {

    if (!this.restoreFolder[folderId]) {

      this.storage.get(folderId).then((viewPublications) => {
        this.publicationList[folderId] = viewPublications
      })

      this.storage.get(folderId + "name").then((viewPublications) => {
        this.FolderDetails[folderId] = viewPublications
      })
    }

    this.restoreFolder[folderId] = true
  }

  updateFolderDetails(folderId, res) {
    this.FolderDetails[folderId] = res
    this.storage.set(folderId + "name", res)
  }

  save(folderId) {
    this.storage.set(folderId + "name", this.FolderDetails)
    this.storage.set(folderId, this.publicationList[folderId]);
  }

  publicationIsPresent(publicationId, folderId) {
    return this.publicationList[folderId].find(e => e.DocumentId == publicationId)
  }
  publicationFind(publicationId, folderId) {
    return this.publicationList[folderId].find(e => e.DocumentId == publicationId)
  }
  publicationFindIndex(publicationId, folderId) {
    return this.publicationList[folderId].findIndex(e => e.DocumentId == publicationId)
  }

  PublicationAddOrUpdate(folderId, publicationId, Publication: Publication) {
    const findIndex = this.publicationFindIndex(publicationId, folderId)
    const found = this.publicationIsPresent(publicationId, folderId)
    if (!found) {
      this.publicationList[folderId].push(Publication)
      this.revertPublicationOrder(folderId);
    } else {
      this.publicationList[folderId][findIndex] = Publication
    }
  }

  deletePost(folderId: any, DocumentId: any) {

    if (this.publicationList[folderId]) {

      this.publicationList[folderId] = this.publicationList[folderId].filter(e => e.DocumentId != DocumentId)

      this.save(folderId)
    }
  }

  getPublicationDetail(folderId) {

    this.publicationService.GetPresidentialAction(folderId).subscribe(res => {
      this.FolderDetails[folderId] = res
      this.storage.set(folderId + "name", res)
    }, (error) => {
      // this.httpErroHandle.httpStatusHandle(error)
    });
  }


  async loadPublication(publicationId, folderId) {
    let Publication = await this.publicationService.GetPublicationWithArrayOfFilesById(publicationId).toPromise();
    let publicationDetails: Publication = this.publicationPipe.itemList(Publication)

    const findIndex = this.publicationFindIndex(publicationId, folderId)
    const found = this.publicationIsPresent(publicationId, folderId)
    if (!found) {
      this.publicationList[folderId].push(publicationDetails)
      this.revertPublicationOrder(folderId);
    } else {

      let a: any = this.publicationList[folderId][findIndex]
      let b: any = publicationDetails

      const fileNamesB = a.Files.map((e) => e.OriginalFileName).join('')
      const fileNamesL = b.Files.map((e) => e.OriginalFileName).join('')

      if (a.Message != b.Message || a.Title != b.Title || a.Files.length != b.Files.length || fileNamesB != fileNamesL) {

        this.publicationList[folderId][findIndex] = publicationDetails
      }

    }

  }


  // async CreatePublication(folderId, publication: Publication) {
  //   const response = await this.publicationService.CreatePublication(folderId, publication).toPromise()
  //   let publicationDetails: Publication = this.publicationPipe.itemList(response)
  //   this.publicationList[folderId].push(publicationDetails)
  //   this.revertPublicationOrder(folderId)
  //   return publicationDetails
  // }

  async setPublication(publicationId, folderId, publicationDetails: Publication) {


    const findIndex = this.publicationFindIndex(publicationId, folderId)
    const found = this.publicationIsPresent(publicationId, folderId)
    if (!found) {
      this.publicationList[folderId].push(publicationDetails)
      this.revertPublicationOrder(folderId)
    } else {
      this.publicationList[folderId][findIndex] = publicationDetails
    }

  }


  async getPublication(publicationId, folderId, publicationDetails: Publication) {


    const findIndex = this.publicationFindIndex(publicationId, folderId)
    const found = this.publicationIsPresent(publicationId, folderId)
    if (!found) {
      this.publicationList[folderId].push(publicationDetails)
      this.revertPublicationOrder(folderId);

    } else {
      return this.publicationList[folderId][findIndex]
    }

  }


  getLocalPublication(folderId, DocumentId) {

    if (this.publicationList[folderId]) {
      return this.publicationList[folderId].find(e => e.DocumentId == DocumentId)
    }

  }


  PublicationHasImage(Publication: Publication) {
    return Publication?.Files?.[0]?.FileBase64 != '' && Publication?.Files?.[0]?.FileBase64 != "data:image/jpg;base64,null"
  }

  hasCapturedImage(Publication: Publication) {
    return Publication?.Files?.[0]?.FileBase64 != '' && Publication?.Files?.[0]?.FileBase64 != "data:image/jpg;base64,null"
  }

  revertPublicationOrder(folderId) {
    //Revert order of the list
    if (this.publicationList[folderId]) {
      this.publicationList[folderId] = this.publicationList[folderId].sort((a, b) => {
        const dateA = new Date(a.DatePublication).getTime();
        const dateB = new Date(b.DatePublication).getTime();
        return dateB - dateA; // Revertendo a ordem aqui
      })
    }
  }

}


